/* Ajustes de comportamento reutilizáveis sobre o Dawn. */
(function () {
  'use strict';

  /* ---------- Carrossel de produtos (home + recomendações) ---------- */
  class ProspirityCarousel extends HTMLElement {
    connectedCallback() {
      if (this.__init) return;
      this.__init = true;
      this.track = this.querySelector('.prospirity-carousel__track');
      this.prev = this.querySelector('.prospirity-carousel__arrow--prev');
      this.next = this.querySelector('.prospirity-carousel__arrow--next');
      this.dots = Array.from(this.querySelectorAll('.prospirity-carousel__dot'));
      if (!this.track) return;
      this.paused = false;
      if (this.prev) this.prev.addEventListener('click', () => { this.step(-1); this.bump(); });
      if (this.next) this.next.addEventListener('click', () => { this.step(1); this.bump(); });
      this.dots.forEach((dot) => dot.addEventListener('click', () => {
        this.track.scrollTo({ left: Number(dot.dataset.slide) * this.cardWidth(), behavior: 'smooth' });
        this.bump();
      }));
      this.track.addEventListener('scroll', () => this.updateDots(), { passive: true });
      this.addEventListener('mouseenter', () => { this.paused = true; });
      this.addEventListener('mouseleave', () => { this.paused = false; });
      this.track.addEventListener('touchstart', () => { this.paused = true; }, { passive: true });
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.reduceMotion = reduce;
      this.onResize = () => this.refresh();
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.track);
      this.inViewport = false;
      this.visibilityObserver = new IntersectionObserver((entries) => {
        this.inViewport = entries[0]?.isIntersecting;
        if (this.inViewport) this.start(); else this.stop();
      }, { threshold: 0.2 });
      this.visibilityObserver.observe(this);
      this.refresh();
    }
    cardWidth() {
      const first = this.track.firstElementChild;
      if (!first) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    step(dir) {
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (max <= 0) return;
      const loop = this.dataset.loop === 'true';
      if (dir > 0 && this.track.scrollLeft >= max - 4) { if (loop) this.track.scrollTo({ left: 0, behavior: 'smooth' }); return; }
      if (dir < 0 && this.track.scrollLeft <= 4) { if (loop) this.track.scrollTo({ left: max, behavior: 'smooth' }); return; }
      this.track.scrollBy({ left: dir * this.cardWidth(), behavior: 'smooth' });
    }
    start() {
      if (this.timer || !this.canScroll || !this.inViewport) return;
      const ms = parseInt(this.dataset.interval, 10) || 5000;
      this.timer = setInterval(() => { if (!this.paused) this.step(1); }, ms);
    }
    stop() { clearInterval(this.timer); this.timer = null; }
    /* Uma bolinha por posição alcançável: com N produtos e V visíveis, o
       trilho só rola até o item N - V; as bolinhas além disso não levariam a
       lugar nenhum. */
    positionCount() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      return Math.min(this.dots.length, Math.round(max / this.cardWidth()) + 1);
    }
    updateDots() {
      if (!this.dots.length) return;
      const positions = this.positionCount();
      const max = this.track.scrollWidth - this.track.clientWidth;
      const index = this.track.scrollLeft >= max - 2
        ? positions - 1
        : Math.min(positions - 1, Math.round(this.track.scrollLeft / this.cardWidth()));
      this.dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
      this.updateArrowState();
    }
    refresh() {
      if (!this.track) return;
      this.canScroll = this.track.scrollWidth - this.track.clientWidth > 2;
      this.classList.toggle('is-scrollable', this.canScroll);
      if (this.dataset.hideControlsWhenStatic === 'true') {
        [this.prev, this.next, this.querySelector('.prospirity-carousel__pagination')].forEach((control) => {
          if (control) control.hidden = !this.canScroll;
        });
      }
      if (!this.canScroll) this.stop();
      else if (this.dataset.autoplay === 'true' && !this.reduceMotion) this.start();
      const positions = this.positionCount();
      this.dots.forEach((dot, i) => { dot.hidden = i >= positions; });
      this.updateDots();
    }
    updateArrowState() {
      if (!this.canScroll || this.dataset.loop === 'true') {
        if (this.prev) this.prev.disabled = !this.canScroll;
        if (this.next) this.next.disabled = !this.canScroll;
        return;
      }
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
    }
    bump() { this.stop(); if (this.dataset.autoplay === 'true' && !this.reduceMotion && this.canScroll) this.start(); }
    disconnectedCallback() { this.stop(); this.resizeObserver?.disconnect(); this.visibilityObserver?.disconnect(); }
  }
  if (!customElements.get('prospirity-carousel')) customElements.define('prospirity-carousel', ProspirityCarousel);

  /* ---------- Adição múltipla ao carrinho (kit, oferta com adicional) ---------- */
  // Adiciona vários itens numa só chamada e abre a gaveta/notificação do Dawn.
  // Sem gaveta, vai para /cart. Lança erro com a mensagem da Shopify.
  async function prospirityAddItems(items, activeElement, source) {
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = { items };
    if (cart) {
      body.sections = cart.getSectionsToRender().map((section) => section.id).join(',');
      body.sections_url = window.location.pathname;
      cart.setActiveElement(activeElement);
    }
    const response = await fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || '');

    if (!cart) { window.location.assign(routes.cart_url); return data; }
    if (!data.key && data.items?.[0]?.key) data.key = data.items[0].key;
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source, cartData: data });
    }
    // Carrinho vazio: o <cart-drawer> nasce com is-empty, que esconde os
    // itens via CSS. O product-form.js do Dawn tira a classe antes de
    // renderizar; sem isso os itens só apareciam depois de recarregar a página.
    cart.classList.remove('is-empty');
    cart.renderContents(data);
    return data;
  }

  function setButtonLoading(button, loading) {
    button.disabled = loading;
    button.classList.toggle('loading', loading);
    button.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
  }

  /* ---------- Kit completo: adiciona todos os produtos do metafield ---------- */
  class ProductKitForm extends HTMLElement {
    connectedCallback() {
      if (this.__init) return;
      this.__init = true;
      this.button = this.querySelector('button');
      this.message = this.querySelector('.prospirity-product-kit__message');
      this.button?.addEventListener('click', () => this.addKit());
    }
    setMessage(message) { if (this.message) this.message.textContent = message; }
    async addKit() {
      if (!this.button || this.button.disabled) return;
      let items;
      try { items = JSON.parse(this.dataset.items || '[]'); } catch { items = []; }
      if (!items.length) { this.setMessage('Não foi possível carregar os itens deste kit.'); return; }

      setButtonLoading(this.button, true);
      this.setMessage('Adicionando kit à sacola...');
      try {
        await prospirityAddItems(items, this.button, 'prospirity-product-kit');
        this.setMessage('Kit adicionado à sacola.');
      } catch (error) {
        this.setMessage(error.message || 'Não foi possível adicionar o kit.');
      } finally {
        setButtonLoading(this.button, false);
      }
    }
  }
  if (!customElements.get('product-kit-form')) customElements.define('product-kit-form', ProductKitForm);

  /* ---------- PDP: oferta com produto adicional (ex.: e-book) ----------
     Adiciona a variante e a quantidade escolhidas na PDP + 1 unidade do
     adicional. Se o adicional já está no carrinho, adiciona só o produto. */
  class ProspirityAddonOffer extends HTMLElement {
    connectedCallback() {
      if (this.__init) return;
      this.__init = true;
      this.button = this.querySelector('button');
      this.message = this.querySelector('.prospirity-addon-offer__message');
      this.button?.addEventListener('click', () => this.add());
    }
    setMessage(message) { if (this.message) this.message.textContent = message; }
    async add() {
      if (!this.button || this.button.disabled) return;
      const form = document.getElementById(`product-form-${this.dataset.section}`);
      const variantInput = form?.querySelector('[name="id"]');
      if (!variantInput || variantInput.disabled || !variantInput.value) {
        this.setMessage(this.dataset.unavailableMessage);
        return;
      }
      const quantityInput = document.getElementById(`Quantity-${this.dataset.section}`);
      const quantity = Math.max(1, parseInt(quantityInput?.value, 10) || 1);
      const addonId = Number(this.dataset.addonVariant);

      setButtonLoading(this.button, true);
      this.setMessage('');
      try {
        let hasAddon = false;
        try {
          const cart = await (await fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } })).json();
          hasAddon = cart.items.some((item) => item.variant_id === addonId);
        } catch { /* sem leitura do carrinho, adiciona os dois */ }
        const items = [{ id: Number(variantInput.value), quantity }];
        if (!hasAddon) items.push({ id: addonId, quantity: 1 });
        await prospirityAddItems(items, this.button, 'prospirity-addon-offer');
        this.setMessage(this.dataset.successMessage);
      } catch (error) {
        this.setMessage(error.message || this.dataset.errorMessage);
      } finally {
        setButtonLoading(this.button, false);
      }
    }
  }
  if (!customElements.get('prospirity-addon-offer')) customElements.define('prospirity-addon-offer', ProspirityAddonOffer);

  /* ---------- PDP: reserva (bloco reservation) ----------
     Antes do envio nativo do formulário de contato (e-mail para a loja),
     manda o formulário de cliente em segundo plano para salvar nome, e-mail e
     tags em Clientes. Falha ou demora no cadastro não bloqueia a reserva. */
  class ProspirityReservation extends HTMLElement {
    connectedCallback() {
      if (this.__init) return;
      this.__init = true;
      this.form = this.querySelector('form');
      this.form?.addEventListener('submit', (event) => this.submit(event));
    }
    async submit(event) {
      if (this.__sending) return;
      event.preventDefault();
      this.__sending = true;
      const button = this.form.querySelector('[type="submit"]');
      if (button) setButtonLoading(button, true);
      const data = new FormData(this.form);
      const name = String(data.get('contact[name]') || '').trim().split(/\s+/);
      const customer = new FormData();
      customer.append('form_type', 'customer');
      customer.append('utf8', '✓');
      customer.append('contact[email]', String(data.get('contact[email]') || '').trim());
      customer.append('contact[first_name]', name.shift() || '');
      customer.append('contact[last_name]', name.join(' '));
      customer.append('contact[tags]', this.dataset.customerTags || 'reserva');
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 5000);
      try {
        await fetch(`${window.Shopify?.routes?.root || '/'}contact`, { method: 'POST', body: customer, signal: controller.signal });
      } catch { /* cadastro é complementar; o e-mail da reserva segue */ }
      clearTimeout(timer);
      HTMLFormElement.prototype.submit.call(this.form);
    }
  }
  if (!customElements.get('prospirity-reservation')) customElements.define('prospirity-reservation', ProspirityReservation);

  /* ---------- PDP: acordeões começam abertos ----------
     Seletor aponta pro accordion nativo do Dawn (bloco collapsible_tab do
     main-product), não mais pro wrapper .prospirity-accordions (removido) do custom_liquid
     antigo — trocado quando o PDP passou a usar blocos nativos. */
  function openProductAccordions() {
    if (window.prospirityDisableAccordionAutoOpen) return;

    const accordions = document.querySelectorAll('.product__accordion details');

    accordions.forEach(function (details, index) {
      if (details.hasAttribute('data-prospirity-touched')) return;

      details.open = index === 0;
      details.setAttribute('data-prospirity-touched', '');
    });
  }

  /* ---------- Card: move o quick-add para dentro da foto (vira overlay) ----------
     Alguns clientes preferem o botão de comprar fora da foto, ao lado do preço
     (comportamento padrão do Dawn). window.prospirityDisableQuickAddOverlay,
     setado antes deste script, desliga esse reposicionamento. */
  function overlayQuickAdd() {
    if (window.prospirityDisableQuickAddOverlay) return;
    document.querySelectorAll('.product-card-wrapper .card').forEach(function (card) {
      const inner = card.querySelector('.card__inner');
      const qa = card.querySelector('.card__content .quick-add');
      if (inner && qa && !inner.contains(qa)) inner.appendChild(qa);
    });
  }

  /* ---------- Header: "SALE" letra a letra ---------- */
  function animateSale() {
    document.querySelectorAll('.header__menu-item').forEach(function (link) {
      if (link.classList.contains('prospirity-sale')) return;
      const span = link.querySelector('span') || link;
      const text = (span.textContent || '').trim();
      if (text.toUpperCase() !== 'SALE') return;
      link.classList.add('prospirity-sale');
      const wrap = document.createElement('span');
      wrap.className = 'prospirity-sale__w';
      text.split('').forEach(function (ch) {
        const c = document.createElement('span');
        c.className = 'prospirity-sale__c';
        c.textContent = ch;
        wrap.appendChild(c);
      });
      span.textContent = '';
      span.appendChild(wrap);
    });
  }

  /* ---------- PDP: link "Consultar tabela de medidas" + modal ---------- */
  function sizeChartLink() {
    const dialog = document.getElementById('ProspiritySizeChart');
    if (!dialog) return;
    document.querySelectorAll('.product-form__input .form__label').forEach(function (label) {
      if (label.querySelector('.prospirity-sizechart-link')) return;
      const name = (label.textContent || '').trim().toLowerCase();
      if (!/^tamanho|^size/.test(name)) return;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'prospirity-sizechart-link';
      btn.textContent = 'Consultar tabela de medidas';
      btn.addEventListener('click', function () { if (typeof dialog.showModal === 'function') dialog.showModal(); });
      label.appendChild(btn);
    });
    const close = dialog.querySelector('.prospirity-sizechart__close');
    if (close && !close.__bound) { close.__bound = true; close.addEventListener('click', function () { dialog.close(); }); }
    if (!dialog.__bound) {
      dialog.__bound = true;
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    }
  }

  /* ---------- Botão "voltar ao topo" ---------- */
  function initBackToTop() {
    const button = document.querySelector('.prospirity-back-to-top');
    if (!button || button.__init) return;
    button.__init = true;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function toggle() { button.classList.toggle('is-visible', window.scrollY > 600); }
    window.addEventListener('scroll', toggle, { passive: true });
    button.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    toggle();
  }

  /* ---------- Âncoras na mesma página ----------
     Links do Theme Editor só aceitam caminhos ("/pages/landing#lista"). Se a URL atual tem
     query string (UTM de anúncio, preview do editor), o navegador recarregaria a página em vez
     de rolar até a âncora. Aqui, link para o mesmo caminho com âncora existente rola no lugar. */
  function initSamePageAnchors() {
    if (document.__prospirityAnchors) return;
    document.__prospirityAnchors = true;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest && event.target.closest('a[href*="#"]');
      if (!link || link.target === '_blank' || link.origin !== window.location.origin) return;
      if (link.pathname === window.location.pathname && link.hash.length > 1) {
        let target = null;
        try { target = document.getElementById(decodeURIComponent(link.hash.slice(1))); } catch (e) { return; }
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', link.hash);
      }
    });
  }

  /* ---------- Classes CSS adicionais do Theme Editor ---------- */
  function classTokens(value) {
    return (value || '').split(/\s+/).filter(function (token) {
      return /^[A-Za-z_-][A-Za-z0-9_-]*$/.test(token);
    });
  }

  function applyCustomClasses(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-prospirity-custom-class]').forEach(function (element) {
      classTokens(element.dataset.prospirityCustomClass).forEach(function (token) {
        element.classList.add(token);
      });
    });
    scope.querySelectorAll('[data-prospirity-section-class]').forEach(function (marker) {
      const section = document.getElementById('shopify-section-' + marker.dataset.prospiritySectionId);
      if (!section) return;
      classTokens(marker.dataset.prospiritySectionClass).forEach(function (token) {
        section.classList.add(token);
      });
    });
  }

  /* ---------- Header da home: mantém a topbar no fluxo ----------
     O header transparente só precisa ser deslocado pela topbar que o
     antecede. Sections anteriores não fazem parte desse cálculo. */
  /* ---------- Grade: visitante escolhe 3 ou 4 produtos por linha ----------
     O snippet prospirity-grid-toggle já aplica a escolha salva em <html> antes
     da grade pintar; aqui ficam o clique e o aria-pressed, que precisa ser
     refeito quando os filtros trocam a grade por AJAX. */
  const GRID_COLS_KEY = 'prospirity-grid-cols';

  function syncGridToggle() {
    const chosen = document.documentElement.dataset.prospirityGridCols;
    document.querySelectorAll('.prospirity-grid-toggle__button').forEach(function (button) {
      const pressed = chosen ? button.dataset.prospirityGridCols === chosen : button.classList.contains('is-default');
      button.setAttribute('aria-pressed', String(pressed));
    });
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest?.('.prospirity-grid-toggle__button');
    if (!button) return;
    const cols = button.dataset.prospirityGridCols;
    document.documentElement.dataset.prospirityGridCols = cols;
    try { localStorage.setItem(GRID_COLS_KEY, cols); } catch (error) { /* navegação privada */ }
    syncGridToggle();
  });

  const homeHeaderOffsetObservers = new WeakMap();

  function findPreviousTopbar(headerSection) {
    let sibling = headerSection.previousElementSibling;
    while (sibling) {
      if (sibling.matches?.('[data-prospirity-topbar]')) return sibling;
      const topbar = sibling.querySelector?.('[data-prospirity-topbar]');
      if (topbar) return topbar;
      sibling = sibling.previousElementSibling;
    }
    return null;
  }

  function setHomeHeaderOffsets() {
    document.querySelectorAll('[data-home-header-overlay]').forEach(function (wrapper) {
      const headerSection = wrapper.closest('.section-header');
      if (!headerSection) return;

      const topbar = findPreviousTopbar(headerSection);
      const offset = topbar && window.getComputedStyle(topbar).display !== 'none'
        ? topbar.getBoundingClientRect().height
        : 0;
      headerSection.style.setProperty('--home-header-offset', `${Math.round(offset)}px`);

      const observed = homeHeaderOffsetObservers.get(wrapper);
      if (observed?.topbar === topbar) return;
      observed?.observer.disconnect();

      if (topbar && 'ResizeObserver' in window) {
        const observer = new ResizeObserver(function () { setHomeHeaderOffsets(); });
        observer.observe(topbar);
        homeHeaderOffsetObservers.set(wrapper, { topbar: topbar, observer: observer });
      } else {
        homeHeaderOffsetObservers.delete(wrapper);
      }
    });
  }

  function run(root) { openProductAccordions(); overlayQuickAdd(); animateSale(); sizeChartLink(); applyCustomClasses(root); setHomeHeaderOffsets(); initBackToTop(); initSamePageAnchors(); syncGridToggle(); }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('resize', setHomeHeaderOffsets, { passive: true });
  document.addEventListener('shopify:section:load', function (event) { run(event.target); });
  document.addEventListener('shopify:section:load', run);
  // Recomendações e busca preditiva injetam cards depois do load.
  new MutationObserver(function () { overlayQuickAdd(); syncGridToggle(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
